import { HelpCircle, LogOut, Settings, FileText } from 'lucide-react';
import { SidebarNavLink } from './SidebarNavLink';
import { useLocation, Link } from 'react-router-dom';

interface SidebarFooterProps {
  onLogout: () => void;
  onHelpClick: () => void;
}

export const SidebarFooter = ({ onLogout, onHelpClick }: SidebarFooterProps) => {
  const location = useLocation();

  return (
    <div className="p-4 border-t border-gray-700 space-y-2">
      <SidebarNavLink
        to="/dashboard/settings"
        icon={<Settings className="h-5 w-5" />}
        label="Settings"
        active={location.pathname === '/dashboard/settings'}
      />
      <button
        onClick={onHelpClick}
        className="flex items-center w-full px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-md transition-colors"
      >
        <HelpCircle className="h-5 w-5 mr-3" />
        Help & Support
      </button>

      {/* Legal link */}
      <Link
        to="/legal"
        className="flex items-center w-full px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-md transition-colors"
      >
        <FileText className="h-5 w-5 mr-3" />
        Legal
      </Link>

      <button
        onClick={onLogout}
        data-testid="sidebar-logout-button"
        className="flex items-center w-full px-4 py-3 text-gray-300 hover:bg-gray-700 hover:text-white rounded-md transition-colors"
      >
        <LogOut className="h-5 w-5 mr-3" />
        Logout
      </button>
    </div>
  );
};
